var render, staticRenderFns
import script from "./v-amount-loading.vue?vue&type=script&lang=js"
export * from "./v-amount-loading.vue?vue&type=script&lang=js"
import style0 from "./v-amount-loading.vue?vue&type=style&index=0&id=6075535b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075535b",
  null
  
)

export default component.exports